<template>
  <div class="sm-forwarding">
    <h4>Current address</h4>
    <div class="sm-forwarding__item home-location">
      <div class="sm-forwarding__item-l">
        <div class="sm-forwarding__item-l-icon">
          <svg class="sm-svg-icon" :class="'sm-svg-home-location'">
            <use :xlink:href="'#home-location'" width="100%" height="100%" />
          </svg>
        </div>
      </div>
      <div class="sm-forwarding__item-r">
        <div class="sm-forwarding__item-r-txt">
          <p>{{userAccount.street}}</p>
          <p>
            <span>{{userAccount.city}}, </span>
            <span v-if="homeState && homeState.code">{{homeState.code}}, </span>
            <span>{{userAccount.zip_code}}, </span>
            <span>{{homeCountry.name}}</span>
          </p>
        </div>
        <div class="sm-forwarding__item-r-cntr">
          <btn-block
            :type="'edit'" 
            :text="'Update'" 
            :icon="'icon-edit'"
            @click="showPopup('form', 'cur')"
          />
        </div>
      </div>
    </div>

    <h4>Forwarding addresses</h4>
    <template v-if="userPlan.has_mail_forwarding || provider.client_level == 1">
      <div 
        v-for="fw in curFwList"
        :key="fw.id"
        class="sm-forwarding__item"
      >
        <div class="sm-forwarding__item-l">
          <div class="sm-forwarding__item-l-icon">
            <svg class="sm-svg-icon" :class="'sm-svg-fwd-address'">
              <use :xlink:href="'#fwd-address'" width="100%" height="100%" />
            </svg>
          </div>
        </div>
        <div class="sm-forwarding__item-r">
          <div class="sm-forwarding__item-r-txt">
            <p v-if="fw.care_of_name">C/O: {{fw.care_of_name}}</p>
            <p v-else-if="fw.attention">ATTN: {{fw.attention}}</p>
            <p>{{fw.street}}</p>
            <p>
              <span>{{fw.city}}, </span>
              <span v-if="fw.stateCode">{{fw.stateCode}}, </span>
              <span>{{fw.zip_code}}, </span>
              <span>{{fw.countryName}}</span>
            </p>
            <!-- <p>Tel: {{fw.phone}}</p> -->
          </div>
          <div class="sm-forwarding__item-r-cntr">
            <a
              href="#"
              class="sm-error"
              @click.prevent="showPopup(fwdAddrList.forward_addresses.length > 1 ? 'del' : 'no-del', 'fwd', fw)"
            >Delete</a>
            <a
              href="#"
              class="sm-link"
              @click.prevent="showPopup('form', 'fwd', fw)"
            >Edit</a>
          </div>
        </div>
      </div>
      <p
        v-if="!curFwList.length"
        class="sm-empty-p"
      >No forwarding addresses.</p>
      <div class="sm-forwarding__bottom">
        <span>Need more Forwarding addresses?</span>
        <a
          v-if="!curFwList.length"
          href="#"
          @click.prevent="showPopup('form', 'new')"
        >Add a forwarding address</a>
        <a
          v-else
          href="#"
          @click.prevent="showPopup('form', 'new')"
        >Add another forwarding address<template v-if="provider.client_level != 1"> for {{formatPrice(userPlan.extra_forward_address_price)}}/month</template></a>
      </div>
    </template>
    <p 
      v-else
      class="disabled"
    >Mail Forwarding is not supported in your plan</p>

    <svg
      xmlns="http://www.w3.org/2000/svg"
      style="position:absolute;visibility:hidden;height:0;pointer-events:none;z-index:-1; "
    >
      <symbol id="home-location" width="88" height="88" viewBox="0 0 88 88" fill="none">
        <path d="M35.999 55.3136L40.319 51.0783M71.999 55.3136L68.399 51.7842M40.319 51.0783L53.999 37.6665L68.399 51.7842M40.319 51.0783V73.6665H41.759H68.399V51.7842" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M58.999 73V58H49.999V73" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M35.9041 73.0321C35.0912 72.1305 16 50.786 16 36.2468C16 24.5313 25.5701 15 37.3333 15C49.0965 15 58.6664 24.5313 58.6667 36.2468M37.3333 46.9366C31.4149 46.9366 26.6001 42.1412 26.6001 36.2468C26.6001 30.3524 31.4151 25.557 37.3333 25.557C43.2516 25.557 48.0664 30.3525 48.0664 36.2469" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </symbol>
      <symbol id="fwd-address" width="88" height="88" viewBox="0 0 88 88" fill="none">
        <path d="M17 40.9271C17 33.058 22.8689 26.6787 30.1086 26.6787C37.3482 26.6787 43.2171 33.058 43.2171 40.9271V58.5952H17V40.9271Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M40.9368 58.5953H69.4337V40.9272C69.4337 33.058 63.0545 26.6788 55.1853 26.6788C47.3161 26.6788 29.5381 26.6787 29.5381 26.6787" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M48.917 47.7662V20.9791M48.917 20.9791V13H70.5746V20.9791H48.917Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M38.6572 59.165V74.5533" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M46.0664 59.165V74.5533" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M29.5381 34.6577V40.927" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </symbol>
    </svg>

    <keep-alive>
      <popup-block
        v-if="popup.isOpen"
        :open="popup.isOpen"
        class="sm-forwarding__popup"
        @close="popup.isOpen = false"
      >
        <template slot="popupContent">
          <form-address
            v-if="popup.type == 'form'"
            :key="`form-address-${formKey}`"
            :title="popup.addressType != 'new' ? 'Address update' : 'Add forwarding address'"
            :btnText="popup.addressType != 'new' ? 'Save changes' : (!curFwList.length ? 'Add forwarding address' : `Add${provider.client_level != 1 ? ' for ' + formatPrice(userPlan.extra_forward_address_price) + '/month' : ''}`)"
            :notCurrent="popup.addressType != 'cur'"
            :initData="formData"
            @submit="sendFormData"
          />
          <confirm-block
            v-else-if="popup.type == 'del'"
            :text="'Do you want to delete this forwarding address?'"
            :confirmText="'Delete'"
            :confirmType="'error'"
            @confirm="confirmFwRemove"
            @cancel="popup.isOpen = false"
          />
          <div 
            v-else-if="popup.type == 'no-del'"
            class="sm-forwarding__popup-warning"
          >
            <h4>Can't remove forwarding address</h4>
            <p>You need to have at least one forwarding address</p>
            <btn-block
              :type="'button'"
              :class="'sm-btn--warning sm-btn--small'"
              :text="'Ok'"
              @click="popup.isOpen = false"
            />
          </div>
          <div 
            v-else-if="popup.type == 'back-error'"
            class="sm-forwarding__popup-warning"
          >
            <h4>{{backError.title}}</h4>
            <p>{{backError.text}}</p>
            <btn-block
              :type="'button'"
              :class="'sm-btn--warning sm-btn--small'"
              :text="'Ok'"
              @click="popup.isOpen = false"
            />
          </div>
        </template>
      </popup-block>
    </keep-alive>

    <sm-spinner :show="showSpinner" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Popup from '@/components/Popup';
import Spinner from '@/components/Spinner';
import {FormatPrice} from '@/utils/general-data';
import Confirm from '@/components/Confirm';
import FormAddress from '@/components/forms/FormAddress';

export default {
  name: 'tab-forwarding',
  components: {
    'popup-block': Popup,
    'sm-spinner': Spinner,
    'confirm-block': Confirm,
    'form-address': FormAddress
  },
  data() {
    return {
      popup: {
        isOpen: false,
        type: 'form', // values: form, del, no-del, back-error
        addressType: 'cur' // values: cur, fwd, new
      },
      curFwList: [],
      curFw: {},
      defaultFormData: {
        attention: '',
        care_of_name: '',
        phone: '',
        country_id: 1,
        state_id: '',
        street: '',
        city: '',
        zip_code: ''
      },
      formData: {},
      showSpinner: false,
      formKey: 0,
      backError: {
        title: '',
        text: ''
      }
    };
  },
  created() {
    if (this.userAccount)
      this.defaultFormData = {
        ...this.defaultFormData,
        country_id: this.userAccount.country_id,
        state_id: this.userAccount.state_id || null
      }

    this.showSpinner = true;
    this.getFwdAddrList()
      .then(() => this.showSpinner = false);
  },
  computed: {
    ...mapGetters({
      userAccount: 'account/userAccount',
      countryList: 'countryList',
      fwdAddrList: 'account/fwdAddrList',
      userPlan: 'account/userPlan',
      provider: 'provider'
    }),
    homeCountry() {
      return this.getCountry(this.userAccount.country_id) || '';
    },
    homeState() {
      if (!this.homeCountry || !this.homeCountry.states || !this.userAccount.state_id)
        return null;

      return this.homeCountry.states.find(state => state.id == this.userAccount.state_id);
    }
  },
  methods: {
    ...mapActions({
      getStateList: 'getStateList',
      getFwdAddrList: 'account/getFwdAddrList',
      updateUser: 'account/updateUser',
      addFwAddress: 'account/addFwAddress',
      editFwAddress: 'account/editFwAddress',
      removeFwAddress: 'account/removeFwAddress'
    }),
    formatPrice: FormatPrice,
    showPopup(type, addressType, fw) {
      this.popup.isOpen = true;
      if (type == 'form') {
        if (addressType != 'new' || this.popup.addressType != 'new')
          this.formKey++;
          
        this.popup.addressType = addressType;
        this.formData = Object.assign({}, this.defaultFormData);
        
        if (addressType == 'cur') {
          Object.keys(this.formData).forEach(key => {
            if (key != 'phone')
              this.formData[key] = this.userAccount[key];
            else
              delete this.formData[key];
          });
        } else if (addressType == 'fwd') {
          this.curFw = fw;

          Object.keys(this.formData).forEach(key => {
            this.formData[key] = this.curFw[key];
          });
        } else if (addressType == 'new') {
          // nothing
        }
      } else if (type == 'del') {
        this.curFw = fw;
      }

      this.popup.type = type;
    },
    getCountry(id) {
      return this.countryList.find((country) => {
        if (country.id == id)
          return country;
      });
    },
    sendFormData(data) {
      this.showSpinner = true;

      if (this.popup.addressType == 'cur') {
        let formDataToSend = new FormData();

        Object.entries(data).forEach(([key, val]) => {
          formDataToSend.append(`account[${key}]`, val);
        });
  
        this.updateUser(formDataToSend)
          .then(res => this.actionCallback())
          .catch(e => {
            console.log(e.response);
            this.actionCallback();
          });
      } else if (this.popup.addressType == 'fwd') {
        // if (!data.state_id) // TEMP, backend issue
        //   data.state_id = 1;

        this.editFwAddress({
          data: data,
          id: this.curFw.id
        })
          .then(res => {
            this.getFwdAddrList()
              .then(() => this.actionCallback());
          })
          .catch(e => {
            this.handleBackError(e, 'update');
          });
      } else if (this.popup.addressType == 'new') {
        // if (!data.state_id) // TEMP, backend issue
        //   data.state_id = 1;

        this.addFwAddress(data)
          .then(res => {
            this.getFwdAddrList()
              .then(() => this.actionCallback());
          })
          .catch(e => {
            console.log(e.response);
            this.actionCallback();
          });
      }

      this.popup.isOpen = false;
    },
    handleBackError(e, action) {
      let err = e.response;

      if (
        err && 
        err.status == 422 && 
        err.data &&
        err.data.errors &&
        err.data.errors.base &&
        err.data.errors.base[0]
      ) {
        this.backError = {
          title: `Can't ${action} address`,
          text: err.data.errors.base[0]
        };
        this.popup.type = 'back-error';
        this.popup.isOpen = true;
        this.showSpinner = false;
      } else {
        this.actionCallback();
      }
    },
    actionCallback() {
      this.showSpinner = false;
      this.popup.isOpen = false;
    },
    confirmFwRemove() {
      this.showSpinner = true;
      this.removeFwAddress(this.curFw.id)
        .then(() => {
          this.getFwdAddrList()
            .then(() => this.actionCallback());
          }
        )
        .catch(e => {
          this.handleBackError(e, 'remove');
        });
    }
  },
  watch: {
    fwdAddrList(val) {
      this.curFwList = [];
      val.forward_addresses.forEach(addr => {
        let fwAddr = Object.assign({}, addr);
        let country = this.countryList.find(country => country.id == fwAddr.country_id);
        fwAddr.countryName = country.name;

        this.getStateList(fwAddr.country_id)
          .then(list => {
            // if (list.length)
            //   fwAddr.stateCode = list.find(state => state.id == fwAddr.state_id).code;

            if (list.length){
              let stateObj = list.find(state => state.id == fwAddr.state_id);
              if(stateObj){
                fwAddr.stateCode = stateObj.code;
              }
            }

            this.curFwList.push(fwAddr);
          });
      });
    },
    userAccount(val) {
      this.defaultFormData = {
        ...this.defaultFormData,
        country_id: val.country_id,
        state_id: val.state_id || null
      }
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/general/mixins.scss';
@import '@/assets/scss/framework/scss-variables.scss';
@import '@/assets/scss/pages/customer/account/components/_forwarding.scss';
</style>
